import React, { useEffect, useState } from "react";
import {
  MdKeyboardArrowLeft,
  MdEast,
  MdSearch,
  MdOutlineLogout,
} from "react-icons/md";
import SideBar from "../SideBar/SideBar";
import Loader from "../../Components/Loader/Loader";
import { Link, NavLink } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import sortButton from "../../assets/sortbutton.svg";
import Balance from "../../assets/balance.svg";
import TabsSection from "../Tabs/TabsSection";
import VouchersDashboard from "./VouchersDashboard";
import ManageVouchers from "./ManageVouchers";
import axios from "axios";
import swal from "sweetalert";
import Pagination from "../Pagination/Pagination";
import NoDataText from "../NoDataText";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import SearchBarResults from "../Search/SearchBarResults";
import { getToken } from "../../Utils/LocalStorage";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

const Transactions = () => {
  const [title, setTitle] = useState("");
  const [currentTab, setcurrentTab] = useState("");
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [g_totalPageCount, setG_TotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [g_limit, setG_Limit] = useState(0);
  // search
  const [searchValue, setsearchValue] = useState("");

  // sort
  const [flag, setFlag] = useState({
    apm_date: 0,
    apm_transaction_id: 0,
    apm_payment_method: 0,
    bi_name: 0,
    product_name: 0,
    apm_amount: 0,
    apm_transaction_fee: 0,
    apm_balance_amount: 0,
  });

  // ['apm_apm_transaction_id','apm_date','apm_payment_method','bi_name','product_name','apm_amount','apm_transaction_fee','apm_balance_amount','created_at']

  const path = window.location.href;
  const endPath = path.split("/");

  const AuthToken = getToken();

  useEffect(() => {
    const url = endPath[4].replace(/-/g, " ");
    const arr = url.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const url_final = arr.join(" ");
    setTitle(url_final);
    if (endPath[4] === "vouchers-dashboard") {
      setcurrentTab("vouchers-dashboard");
    }
    if (endPath[4] === "manage-vouchers") {
      setcurrentTab("manage-vouchers");
    }
    if (endPath[4] === "transactions") {
      setcurrentTab("transactions");
    }
  }, [path]);

  useEffect(() => {
    getTableData();
  }, [pageNumber]);

  const getTableData = () => {
    const cityId = localStorage.getItem("cityId");
    axios({
      url:
        process.env.REACT_APP_COMMON_URL + "vms/admin/paymentlist_marketplace",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Token: AuthToken,
      },
      data: {
        mms_city_id: parseInt(cityId),
        offset: pageNumber,
        limit: 5,
        // user_id:1,
        // search_value: '',
        // column_name: '',
        sort_type: 0,
      },
    })
      .then((response) => {
        setData(response.data);
        setTableRows(response.data.data);
        setglobalTableRows(response.data.data);
        setTotalPageCount(response.data.total_rows);
        setG_TotalPageCount(response.data.total_rows);
        setLimit(response.data.limit);
        setG_Limit(response.data.limit);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        swal({
          // title: "Error!",
          title: `${err.data.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        swal.stopLoading();
        swal.close();
      });
  };

  // search
  const handleSearchInput = (e) => {
    setsearchValue(e.target.value);
    if (e.target.value.length == 0) {
      setTableRows(globalTableRows);
      setLimit(g_limit);
      setTotalPageCount(g_totalPageCount);
    }
  };
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = async (e) => {
    // setLoading(true);
    const cityId = localStorage.getItem("cityId");
    axios({
      url:
        process.env.REACT_APP_COMMON_URL + "vms/admin/paymentlist_marketplace",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Token: AuthToken,
      },
      data: {
        mms_city_id: parseInt(cityId),
        search_value: searchValue,
        limit: 5,
      },
    })
      .then((response) => {
        setData(response.data);
        setTableRows(response.data.data);
        setTotalPageCount(response.data.total_rows);
        setLimit(response.data.limit);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        swal({
          title: `${err.data.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        swal.stopLoading();
        swal.close();
      });
  };

  // sort
  // Api for sort
  const handleSort = async (search, sortNo, colValue) => {
    const cityId = localStorage.getItem("cityId");
    axios({
      url:
        process.env.REACT_APP_COMMON_URL + "vms/admin/paymentlist_marketplace",
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Token: AuthToken,
      },
      data: {
        mms_city_id: parseInt(cityId),
        offset: search ? 0 : pageNumber,
        search_value: search,
        column_name: colValue,
        sort_type: sortNo,
        limit: 5,
      },
    })
      .then((response) => {
        setData(response.data);
        setTableRows(response.data.data);
        setTotalPageCount(response.data.total_rows);
        setLimit(response.data.limit);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        swal({
          title: `${err.data.message}`,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        swal.stopLoading();
        swal.close();
      });
  };

  // function to sort-button
  const HandleSortCol = (value) => {
    // apm_date: 0,
    if (value == "apm_date") {
      if (flag.apm_date === 0) {
        handleSort(searchValue, 1, "apm_date");
        setFlag((item) => {
          return { ...item, apm_date: 1 };
        });
      } else if (flag.apm_date === 1) {
        handleSort(searchValue, 2, "apm_date");
        setFlag((item) => {
          return { ...item, apm_date: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_date");
        setFlag((item) => {
          return { ...item, apm_date: 0 };
        });
      }
    }
    // apm_transaction_id: 0,
    if (value == "apm_transaction_id") {
      if (flag.apm_transaction_id === 0) {
        handleSort(searchValue, 1, "apm_transaction_id");
        setFlag((item) => {
          return { ...item, apm_transaction_id: 1 };
        });
      } else if (flag.apm_transaction_id === 1) {
        handleSort(searchValue, 2, "apm_transaction_id");
        setFlag((item) => {
          return { ...item, apm_transaction_id: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_transaction_id");
        setFlag((item) => {
          return { ...item, apm_transaction_id: 0 };
        });
      }
    }
    // apm_payment_method:0
    if (value == "apm_payment_method") {
      if (flag.apm_payment_method === 0) {
        handleSort(searchValue, 1, "apm_payment_method");
        setFlag((item) => {
          return { ...item, apm_payment_method: 1 };
        });
      } else if (flag.apm_payment_method === 1) {
        handleSort(searchValue, 2, "apm_payment_method");
        setFlag((item) => {
          return { ...item, apm_payment_method: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_payment_method");
        setFlag((item) => {
          return { ...item, apm_payment_method: 0 };
        });
      }
    }
    // bi_name: 0,
    if (value == "bi_name") {
      if (flag.bi_name === 0) {
        handleSort(searchValue, 1, "bi_name");
        setFlag((item) => {
          return { ...item, bi_name: 1 };
        });
      } else if (flag.bi_name === 1) {
        handleSort(searchValue, 2, "bi_name");
        setFlag((item) => {
          return { ...item, bi_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "bi_name");
        setFlag((item) => {
          return { ...item, bi_name: 0 };
        });
      }
    }
    // product_name
    if (value == "product_name") {
      if (flag.product_name === 0) {
        handleSort(searchValue, 1, "product_name");
        setFlag((item) => {
          return { ...item, product_name: 1 };
        });
      } else if (flag.product_name === 1) {
        handleSort(searchValue, 2, "product_name");
        setFlag((item) => {
          return { ...item, product_name: 2 };
        });
      } else {
        handleSort(searchValue, 0, "product_name");
        setFlag((item) => {
          return { ...item, product_name: 0 };
        });
      }
    }

    // apm_amount
    if (value == "apm_amount") {
      if (flag.apm_amount === 0) {
        handleSort(searchValue, 1, "apm_amount");
        setFlag((item) => {
          return { ...item, apm_amount: 1 };
        });
      } else if (flag.apm_amount === 1) {
        handleSort(searchValue, 2, "apm_amount");
        setFlag((item) => {
          return { ...item, apm_amount: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_amount");
        setFlag((item) => {
          return { ...item, apm_amount: 0 };
        });
      }
    }
    // apm_transaction_fee
    if (value == "apm_transaction_fee") {
      if (flag.apm_transaction_fee === 0) {
        handleSort(searchValue, 1, "apm_transaction_fee");
        setFlag((item) => {
          return { ...item, apm_transaction_fee: 1 };
        });
      } else if (flag.apm_transaction_fee === 1) {
        handleSort(searchValue, 2, "apm_transaction_fee");
        setFlag((item) => {
          return { ...item, apm_transaction_fee: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_transaction_fee");
        setFlag((item) => {
          return { ...item, apm_transaction_fee: 0 };
        });
      }
    }

    // apm_balance_amount
    if (value == "apm_balance_amount") {
      if (flag.apm_balance_amount === 0) {
        handleSort(searchValue, 1, "apm_balance_amount");
        setFlag((item) => {
          return { ...item, apm_balance_amount: 1 };
        });
      } else if (flag.apm_balance_amount === 1) {
        handleSort(searchValue, 2, "apm_balance_amount");
        setFlag((item) => {
          return { ...item, apm_balance_amount: 2 };
        });
      } else {
        handleSort(searchValue, 0, "apm_balance_amount");
        setFlag((item) => {
          return { ...item, apm_balance_amount: 0 };
        });
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 VoucherDash">
          <BackButton />
          <p className="page-maintitle">Vouchers</p>
          <div className="acc-dashboard mt-4">
            <TabsSection />
            <div className="acc-dashboard mt-4 transaction-body">
              <div className="manage-vou-main pt-3 pb-3 transaction-sub-head">
                <p className="page-maintitle pt-2">Transactions</p>
                <div className="manage-vou">
                  <div className="search-bar">
                    <MdSearch />
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchValue}
                      onChange={(e) => handleSearchInput(e)}
                      onKeyPress={handleKeypress}
                    />
                    <Button variant="outline-secondary" onClick={handleSearch}>
                      Search
                    </Button>
                  </div>
                  {/* <Button
                    variant="primary"
                    className="create-btn export-btn-main"
                  >
                    Export <MdOutlineLogout className="export-btn" />
                  </Button> */}
                  <div className="bal_div">
                    <img loading="lazy" src={Balance} />
                    <p className="tran-balance">
                      Balance : $
                      {data.balance_amount == "" ? 0 : data.balance_amount}
                    </p>
                  </div>
                </div>
              </div>
              <SearchBarResults SearchValue={searchValue} />
              <div className="table-responsive-xl black-header innerTran">
                <table className="recentact-table table ver-middle manage-vou-table innerTransactionTable">
                  <thead>
                    <tr className="innerTran-tr-head">
                      {/* 1 */}
                      <th onClick={() => HandleSortCol("apm_date")}>
                        <Button className="btn btn-primary sortIcon">
                          Date
                          {flag.apm_date === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_date === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 2 */}
                      <th onClick={() => HandleSortCol("apm_transaction_id")}>
                        <Button className="btn btn-primary sortIcon">
                          Transaction Id
                          {flag.apm_transaction_id === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_transaction_id === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 3 */}
                      <th onClick={() => HandleSortCol("apm_payment_method")}>
                        <Button className="btn btn-primary sortIcon">
                          Transaction Type
                          {flag.apm_payment_method === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_payment_method === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 4 */}
                      <th onClick={() => HandleSortCol("bi_name")}>
                        <Button className="btn btn-primary sortIcon">
                          Business Name
                          {flag.bi_name === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.bi_name === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 5 */}
                      <th onClick={() => HandleSortCol("product_name")}>
                        <Button className="btn btn-primary sortIcon">
                          Transaction Name
                          {flag.product_name === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.product_name === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 6 */}
                      <th onClick={() => HandleSortCol("apm_amount")}>
                        <Button className="btn btn-primary sortIcon">
                          Transaction Amount
                          {flag.apm_amount === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_amount === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      {/* 7 */}
                      <th onClick={() => HandleSortCol("apm_transaction_fee")}>
                        <Button className="btn btn-primary sortIcon">
                          Marketplace Fees
                          {flag.apm_transaction_fee === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_transaction_fee === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>

                      {/* 8 */}
                      <th onClick={() => HandleSortCol("apm_balance_amount")}>
                        <Button className="btn btn-primary sortIcon">
                          Balance
                          {flag.apm_balance_amount === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.apm_balance_amount === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {TableRows?.length != 0 ? (
                      <>
                        {TableRows.map((item, key) => {
                          return (
                            <tr className="innerTran-tr-body">
                              <td>{FormatDateShortMonth(item.apm_date)}</td>
                              <td>#{item.apm_transaction_id}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.apm_payment_method}
                              </td>

                              <td title={item.bi_name}>
                                {item.bi_name.length > 30
                                  ? item.bi_name.substring(0, 30) + "..."
                                  : item.bi_name}
                              </td>

                              <td title={item.product_name}>
                                {item.product_name.length > 30
                                  ? item.product_name.substring(0, 30) + "..."
                                  : item.product_name}
                              </td>
                              <td>${item.apm_amount}</td>
                              <td>${item.apm_transaction_fee}</td>
                              <td>${item.apm_balance_amount}</td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr class="toggle-row">
                        <td colspan="11">
                          <p class="noData">{NoDataText.ErrText}</p>{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <Pagination
            totalPageCount={totalPageCount}
            setPageNumber={setPageNumber}
            limit={limit}
          />
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Transactions;
